import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';

import awsConfig from './aws-exports';
import { App } from './components';
import { decodeAmplifyState } from './utils/authUtils';
import { getEnvironmentInfo, isTrustedOrigin } from './utils/envUtils';
import { initialize as initializeSentry } from './utils/sentryUtils';

import './index.css';

const { REACT_APP_VERSION: reactAppVersion } = import.meta.env;
const version = reactAppVersion || 'development';
const { env } = getEnvironmentInfo(window.location.host);

initializeSentry(env, version);

const urlParams = new URLSearchParams(window.location.search);
const code = urlParams.get('code');
const state = urlParams.get('state');

const targetOrigin = decodeAmplifyState(state);

// Validate that the target origin is trusted before redirecting
if (code && targetOrigin && targetOrigin !== window.location.origin && isTrustedOrigin(targetOrigin)) {
    window.location.href = `${targetOrigin}/lettuce/?${urlParams.toString()}`;
} else {
    Amplify.configure(awsConfig);

    const container = document.getElementById('root');
    const root = ReactDOM.createRoot(container);
    const queryClient = new QueryClient();
    root.render(
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>,
    );
}
